import { Numr } from './Numr.js';

export const Locl = {
    set: function (key: string, txt: any, unformatted = false) {
        if (unformatted) {
            localStorage.setItem(key, txt);
        } else {
            localStorage.setItem(key, JSON.stringify(txt));
        }
    },
    get: function (key: string, unformatted = false) {
        const information = localStorage.getItem(key);
        if (information) {
            if (!unformatted) {
                try {
                    const parsed = JSON.parse(information);
                    return parsed;
                } catch (e) {
                    if (Numr.validate(Number(information))) {
                        return Number(information)
                    } else {
                        return String(information);
                    }
                }
            }
            return information;
        }
    },
    delete: function (key: string) {
        localStorage.removeItem(key);
    }
};